import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../icons/error-grey.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { GetHelp, ReturnToBookingPortal } from './buttons';
import { RequestDeniedProps } from './types';

export const RequestDenied = ({ guests, date, time, restaurantName, bookingId, linkTo }: RequestDeniedProps) => {
	const { t } = useTranslation();

	return (
		<ResultPageLayout headerIcon={ErrorIcon} iconAltText={t('titles.request_denied')}>
			<ResultPageLayout.Title>{t('titles.request_denied')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_request_denied', {
						restaurantName,
						guests,
						plural: guests > 1 ? 's' : '',
						date,
						time
					})}
				</p>
				<p>{t('messages.check_email_details')}</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<ReturnToBookingPortal to={linkTo} />
				<GetHelp bookingId={bookingId} />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
